import type { SVGProps } from 'react';
export const SvgBlock = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={21}
		height={21}
		fill="none"
		viewBox="0 0 21 21"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12.917 2.166H8.083c-.566 0-1.366.333-1.766.733L2.9 6.316c-.4.4-.733 1.2-.733 1.767v4.833c0 .567.333 1.367.733 1.767l3.417 3.416c.4.4 1.2.734 1.766.734h4.834c.566 0 1.366-.334 1.766-.734l3.417-3.416c.4-.4.733-1.2.733-1.767V8.083c0-.567-.333-1.367-.733-1.767l-3.417-3.417c-.4-.4-1.2-.733-1.766-.733M4.617 16.4 16.4 4.618"
		/>
	</svg>
);
